import isBot from 'isbot';
import PubSub from 'pubsub-js';
import { isServer } from './misc.esm.js';

var AnalyticsProperties;
(function (AnalyticsProperties) {
    AnalyticsProperties["QUEUE"] = "analyticsQueue";
    AnalyticsProperties["USER"] = "userProperties";
})(AnalyticsProperties || (AnalyticsProperties = {}));
var AnalyticsQueue = /** @class */ (function () {
    function AnalyticsQueue(_debug, _filterBots) {
        if (_debug === void 0) { _debug = false; }
        if (_filterBots === void 0) { _filterBots = true; }
        this._debug = _debug;
        this._filterBots = _filterBots;
        this._pubSubToken = [];
        if (!_debug)
            return;
        var tokens = Object.values(AnalyticsProperties).map(function (property) {
            return PubSub.subscribe(property, function (msg, data) {
                // eslint-disable-next-line no-console
                console.debug(msg, data);
            });
        });
        this._pubSubToken = tokens;
    }
    AnalyticsQueue.prototype.createEmptyAnalytics = function () {
        var _a;
        if (!window._analytics) {
            window._analytics = (_a = {},
                _a[AnalyticsProperties.QUEUE] = [],
                _a[AnalyticsProperties.USER] = {},
                _a);
        }
    };
    AnalyticsQueue.prototype.verifyServerAndBots = function () {
        // there is no window object on the server. We need to check if there is a window object in case logEvent is called on the server
        if (isServer())
            return;
        // filter out bots
        if (this._filterBots && isBot(navigator.userAgent))
            return;
        return true;
    };
    /**
     * Function that adds events to the event queue on Window._analytics
     * @param {AnalyticsQueueMessageEvent} postMessage - message to be handled
     */
    AnalyticsQueue.prototype.writeMessageToWindowObject = function (msg) {
        this.createEmptyAnalytics();
        if (!window._analytics[AnalyticsProperties.QUEUE]) {
            window._analytics[AnalyticsProperties.QUEUE] = [];
        }
        var eventName = msg.eventName, _a = msg.eventProperties, eventProperties = _a === void 0 ? {} : _a, timestamp = msg.timestamp;
        window._analytics[AnalyticsProperties.QUEUE].push({
            eventName: eventName,
            eventProperties: eventProperties,
            timestamp: timestamp,
        });
    };
    /**
     * Function that set properties to the userProperties on Window._analytics
     * @param {AnalyticsUserPropertiesArguments} args - arguments to be handled
     */
    AnalyticsQueue.prototype.writeUserPropertiesToWindowObject = function (args) {
        this.createEmptyAnalytics();
        if (!window._analytics[AnalyticsProperties.USER]) {
            window._analytics[AnalyticsProperties.USER] = {};
        }
        window._analytics[AnalyticsProperties.USER] = args;
    };
    AnalyticsQueue.prototype.stop = function () {
        if (!this._debug)
            return;
        this._pubSubToken.map(function (token) { return PubSub.unsubscribe(token); });
    };
    AnalyticsQueue.prototype.logEvent = function (_a) {
        var eventName = _a.eventName, _b = _a.eventProperties, eventProperties = _b === void 0 ? {} : _b;
        if (!this.verifyServerAndBots())
            return;
        var message = {
            eventName: eventName,
            eventProperties: eventProperties,
            timestamp: Date.now(),
        };
        this.writeMessageToWindowObject(message);
        PubSub.publish(AnalyticsProperties.QUEUE, message);
    };
    AnalyticsQueue.prototype.setUserProperties = function (args) {
        if (!this.verifyServerAndBots())
            return;
        this.writeUserPropertiesToWindowObject(args);
        PubSub.publish(AnalyticsProperties.USER, args);
    };
    AnalyticsQueue.prototype.pageViewLogEvent = function (currentPage, eventProperties) {
        var eventName = "View ".concat(currentPage, " Page");
        this.logEvent({
            eventName: eventName,
            eventProperties: eventProperties,
        });
    };
    AnalyticsQueue.prototype.linkClickLogEvent = function (linkName, currentPage, eventProperties) {
        var eventName = "Click to ".concat(linkName, " on ").concat(currentPage);
        this.logEvent({
            eventName: eventName,
            eventProperties: eventProperties,
        });
    };
    return AnalyticsQueue;
}());

export { AnalyticsProperties, AnalyticsQueue };
//# sourceMappingURL=analyticsQueue.esm.js.map
